module.exports = __webpack_public_path__ + "img/icon_rss.1868c638.svg";